<template>
  <div class="gdpr">
    <h2>Datenschutzrichtlinien</h2>
    <div class="content">
      Text der Datenschutzrichtlinie
    </div>
  </div>
</template>